import * as i1 from '@angular/cdk/table';
import { CdkCellDef, CdkHeaderCellDef, CdkFooterCellDef, CdkCell, CdkColumnDef, CdkHeaderCell, CdkFooterCell, DataSource, CdkTableModule, DataRowOutlet, FooterRowOutlet, HeaderRowOutlet, NoDataRowOutlet, CdkTable, _CoalescedStyleScheduler, _COALESCED_STYLE_SCHEDULER, CDK_TABLE, CDK_TABLE_TEMPLATE, CdkRow, CdkCellOutlet, CDK_ROW_TEMPLATE, CdkHeaderRowDef, CdkHeaderRow, CdkRowDef, CdkFooterRowDef, CdkFooterRow } from '@angular/cdk/table';
import * as i0 from '@angular/core';
import { Directive, Input, HostBinding, Injectable, EventEmitter, forwardRef, Output, Inject, ContentChildren, ChangeDetectionStrategy, ViewEncapsulation, Component, NgModule } from '@angular/core';
import { Subject, BehaviorSubject, Subscription, noop } from 'rxjs';
import { _DisposeViewRepeaterStrategy, _VIEW_REPEATER_STRATEGY } from '@angular/cdk/collections';
import { CommonModule } from '@angular/common';

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricCellDefDirective`:
 * @example
 * ```typescript
 * import { CentricCellDefDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricCellDefDirective extends CdkCellDef {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricCellDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricCellDefDirective, isStandalone: true, selector: "[centricCellDef]", providers: [{ provide: CdkCellDef, useExisting: CentricCellDefDirective }], usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricCellDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[centricCellDef]',
                    providers: [{ provide: CdkCellDef, useExisting: CentricCellDefDirective }],
                    standalone: true
                }]
        }] });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricFilterCellDefDirective`:
 * @example
 * ```typescript
 * import { CentricFilterCellDefDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricFilterCellDefDirective extends CdkHeaderCellDef {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFilterCellDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricFilterCellDefDirective, isStandalone: true, selector: "[centricFilterCellDef]", providers: [{ provide: CdkHeaderCellDef, useExisting: CentricFilterCellDefDirective }], usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFilterCellDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[centricFilterCellDef]',
                    providers: [{ provide: CdkHeaderCellDef, useExisting: CentricFilterCellDefDirective }],
                    standalone: true
                }]
        }] });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricFooterCellDefDirective`:
 * @example
 * ```typescript
 * import { CentricFooterCellDefDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricFooterCellDefDirective extends CdkFooterCellDef {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFooterCellDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricFooterCellDefDirective, isStandalone: true, selector: "[centricFooterCellDef]", providers: [{ provide: CdkFooterCellDef, useExisting: CentricFooterCellDefDirective }], usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFooterCellDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[centricFooterCellDef]',
                    providers: [{ provide: CdkFooterCellDef, useExisting: CentricFooterCellDefDirective }],
                    standalone: true
                }]
        }] });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricHeaderCellDefDirective`:
 * @example
 * ```typescript
 * import { CentricHeaderCellDefDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricHeaderCellDefDirective extends CdkHeaderCellDef {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricHeaderCellDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricHeaderCellDefDirective, isStandalone: true, selector: "[centricHeaderCellDef]", providers: [{ provide: CdkHeaderCellDef, useExisting: CentricHeaderCellDefDirective }], usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricHeaderCellDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[centricHeaderCellDef]',
                    providers: [{ provide: CdkHeaderCellDef, useExisting: CentricHeaderCellDefDirective }],
                    standalone: true
                }]
        }] });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricCellDirective`:
 * @example
 * ```typescript
 * import { CentricCellDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricCellDirective extends CdkCell {
    elementRef;
    containerClass = true;
    _isCellContentAlignedToRight = false;
    constructor(columnDef, elementRef) {
        super(columnDef, elementRef);
        this.elementRef = elementRef;
        elementRef.nativeElement.classList.add('centric-column-cell');
    }
    /**
     * The cell content can be aligned to right
     */
    get isCellContentAlignedToRight() {
        return this._isCellContentAlignedToRight;
    }
    set isCellContentAlignedToRight(value) {
        this._isCellContentAlignedToRight = value;
        if (value) {
            this.elementRef.nativeElement.classList.add('align-to-right');
        }
        else {
            this.elementRef.nativeElement.classList.remove('align-to-right');
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricCellDirective, deps: [{ token: i1.CdkColumnDef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricCellDirective, isStandalone: true, selector: "centric-cell, td[centric-cell]", inputs: { isCellContentAlignedToRight: "isCellContentAlignedToRight" }, host: { properties: { "class.centric-cell": "this.containerClass" } }, usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'centric-cell, td[centric-cell]',
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i1.CdkColumnDef }, { type: i0.ElementRef }], propDecorators: { containerClass: [{
                type: HostBinding,
                args: ['class.centric-cell']
            }], isCellContentAlignedToRight: [{
                type: Input
            }] } });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricColumnDefDirective`:
 * @example
 * ```typescript
 * import { CentricColumnDefDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricColumnDefDirective extends CdkColumnDef {
    /**
     * The property indicates the state of the sticky flag
     */
    get sticky() {
        return this._customSticky;
    }
    set sticky(newValue) {
        this._customSticky = newValue;
    }
    /**
     * Unique name for the column
     */
    get name() {
        return this._name;
    }
    set name(name) {
        this._setNameInput(name);
    }
    _customSticky = false;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricColumnDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricColumnDefDirective, isStandalone: true, selector: "[centricColumnDef]", inputs: { sticky: "sticky", name: ["centricColumnDef", "name"] }, providers: [{ provide: CdkColumnDef, useExisting: CentricColumnDefDirective }], usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricColumnDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[centricColumnDef]',
                    providers: [{ provide: CdkColumnDef, useExisting: CentricColumnDefDirective }],
                    standalone: true
                }]
        }], propDecorators: { sticky: [{
                type: Input
            }], name: [{
                type: Input,
                args: ['centricColumnDef']
            }] } });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricFilterCellDirective`:
 * @example
 * ```typescript
 * import { CentricFilterCellDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricFilterCellDirective extends CdkHeaderCell {
    containerClass = true;
    constructor(columnDef, elementRef) {
        super(columnDef, elementRef);
        elementRef.nativeElement.classList.add('centric-column-filter-cell');
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFilterCellDirective, deps: [{ token: i1.CdkColumnDef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricFilterCellDirective, isStandalone: true, selector: "centric-filter-cell, th[centric-filter-cell]", host: { properties: { "class.centric-filter-cell": "this.containerClass" } }, usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFilterCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'centric-filter-cell, th[centric-filter-cell]',
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i1.CdkColumnDef }, { type: i0.ElementRef }], propDecorators: { containerClass: [{
                type: HostBinding,
                args: ['class.centric-filter-cell']
            }] } });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricFooterCellDirective`:
 * @example
 * ```typescript
 * import { CentricFooterCellDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricFooterCellDirective extends CdkFooterCell {
    containerClass = true;
    constructor(columnDef, elementRef) {
        super(columnDef, elementRef);
        elementRef.nativeElement.classList.add('centric-column-footer');
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFooterCellDirective, deps: [{ token: i1.CdkColumnDef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricFooterCellDirective, isStandalone: true, selector: "centric-footer-cell, td[centric-footer-cell]", host: { properties: { "class.centric-footer-cell": "this.containerClass" } }, usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFooterCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'centric-footer-cell, td[centric-footer-cell]',
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i1.CdkColumnDef }, { type: i0.ElementRef }], propDecorators: { containerClass: [{
                type: HostBinding,
                args: ['class.centric-footer-cell']
            }] } });

class DataGridService {
    sortColumnClear$ = new Subject();
    sortRowClear$ = new Subject();
    previousClickedColumn;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DataGridService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DataGridService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DataGridService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

const MIN_WIDTH_DEFAULT = 152;
const MIN_WIDTH_DENSE = 128;
const MIN_WIDTH_SMALL = 120;
var DataGridMinWidthSize;
(function (DataGridMinWidthSize) {
    DataGridMinWidthSize[DataGridMinWidthSize["default"] = 152] = "default";
    DataGridMinWidthSize[DataGridMinWidthSize["dense"] = 128] = "dense";
    DataGridMinWidthSize[DataGridMinWidthSize["small"] = 120] = "small";
})(DataGridMinWidthSize || (DataGridMinWidthSize = {}));

var DataGridSortDirection;
(function (DataGridSortDirection) {
    DataGridSortDirection["none"] = "none";
    DataGridSortDirection["asc"] = "ascending";
    DataGridSortDirection["desc"] = "descending";
})(DataGridSortDirection || (DataGridSortDirection = {}));

const SORT_BUTTON_CLASS = 'centric-sort-button';
/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricHeaderCellDirective`:
 * @example
 * ```typescript
 * import { CentricHeaderCellDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricHeaderCellDirective extends CdkHeaderCell {
    columnDef;
    elementRef;
    renderer;
    dgService;
    containerClass = true;
    /**
     * Enable the resize on the column.
     * It only works if the table is resizable
     */
    get isResizable() {
        const tableElement = this.element.nativeElement.parentElement?.parentElement?.parentElement;
        const isResizableTable = tableElement?.className.includes('has-resize-directive');
        return isResizableTable ? this._isResizable : false;
    }
    set isResizable(value) {
        this._isResizable = value;
        this.resizePropertiesChange.emit();
    }
    /**
     * Property that sets the width of a column that is not resizable.
     * It only works if the table is resizable
     */
    get fixedWidth() {
        return this.isResizable ? null : (this._fixedWidth ?? this.minWidth);
    }
    set fixedWidth(value) {
        this._fixedWidth = value;
        if (!this.isResizable) {
            this.resizePropertiesChange.emit();
        }
    }
    /**
     * Property that sets the width of a column that is resizable.
     * It only works if the table is resizable
     */
    get resizeWidth() {
        const validResizeWidth = this._resizeWidth && this._resizeWidth < this.minWidth ? this.minWidth : this._resizeWidth;
        return this.isResizable ? validResizeWidth : null;
    }
    set resizeWidth(value) {
        this._resizeWidth = value;
        this.resizePropertiesChange.emit();
    }
    /**
     * Property can be used to make the table sortable
     */
    get sortable() {
        return this.isSortable;
    }
    set sortable(value) {
        this.isSortable = value;
        this.updateAriaSort(this.sortStatus.toString(), value);
        this.handleClick(value);
        if (value) {
            this.addSortElements();
            if (this.sortButton) {
                this.updateAriaDescription(this.ariaDescription);
            }
        }
        else {
            this.removeSortElements();
        }
    }
    get ariaDescription() {
        return this._ariaDescription;
    }
    set ariaDescription(value) {
        this._ariaDescription = value;
        if (this.sortable && this.sortButton) {
            this.updateAriaDescription(value);
        }
    }
    /**
     * The header cell content can be aligned to right
     */
    get isHeaderContentAlignedToRight() {
        return this._isHeaderContentAlignedToRight;
    }
    set isHeaderContentAlignedToRight(value) {
        this._isHeaderContentAlignedToRight = value;
        if (value) {
            this.elementRef.nativeElement.classList.add('align-to-right');
        }
        else {
            this.elementRef.nativeElement.classList.remove('align-to-right');
        }
    }
    /**
     * The sorting will be made only by one column and all the sorting filters from the other columns will be reseted
     */
    get singleColumnSort() {
        return this.hasSingleColumnSort;
    }
    set singleColumnSort(value) {
        this.hasSingleColumnSort = value;
    }
    /**
     * The column can be sortable ascending or descending
     */
    get sortStatus() {
        return this.sortStatusColumn;
    }
    set sortStatus(newStatus) {
        this.sortStatusColumn = newStatus;
        if (this.sortable) {
            this.replaceSortClass(this.elementRef.nativeElement, `sort-${newStatus.toString()}`);
            this.updateAriaSort(newStatus.toString(), this.sortable);
            this.updatePreviousClickedColumn();
        }
    }
    /**
     * Emits the sort direction
     */
    sort = new EventEmitter();
    /**
     * Emits when the isResizable, fixedWidth or resizeWidth inputs were changed
     */
    resizePropertiesChange = new EventEmitter();
    sortStatusColumn = DataGridSortDirection.none;
    isSortable = false;
    hasSingleColumnSort = false;
    element;
    clickEventListener;
    _ariaDescription;
    _isHeaderContentAlignedToRight = false;
    _isResizable = true;
    _fixedWidth;
    _resizeWidth = null;
    get sortButton() {
        return this.element.nativeElement.getElementsByClassName(SORT_BUTTON_CLASS)[0];
    }
    get minWidth() {
        const tableElement = this.element.nativeElement.parentElement?.parentElement?.parentElement;
        const tableClassList = tableElement?.className.split(' ');
        if (tableClassList?.includes('is-small')) {
            return DataGridMinWidthSize.small;
        }
        return tableClassList?.includes('is-dense') ? DataGridMinWidthSize.dense : DataGridMinWidthSize.default;
    }
    constructor(columnDef, elementRef, renderer, dgService) {
        super(columnDef, elementRef);
        this.columnDef = columnDef;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.dgService = dgService;
        elementRef.nativeElement.classList.add('centric-column-header');
        this.element = elementRef;
        this.clickEventListener = ((event) => this.onSort(event));
    }
    ngAfterViewInit() {
        this.updatePreviousClickedColumn();
        this.createSortButtonIfNotExist();
    }
    ngOnDestroy() {
        this.sortButton?.removeEventListener('click', this.clickEventListener);
    }
    updatePreviousClickedColumn() {
        if (this.singleColumnSort && this.sortStatus !== DataGridSortDirection.none) {
            const columnText = this.elementRef.nativeElement.textContent;
            if (columnText) {
                this.dgService.previousClickedColumn = columnText.trim();
            }
        }
    }
    onSort(event) {
        const columnName = event.target.textContent?.trim();
        if (this.sortable && columnName) {
            if (this.singleColumnSort) {
                this.updateCellsWithSingleSort(columnName);
            }
            this.updateSortStatus();
            this.dgService.sortColumnClear$.next(columnName);
        }
    }
    updateCellsWithSingleSort(column) {
        const rows = this.elementRef.nativeElement.parentElement?.children;
        if (rows) {
            this.updatePreviousCellArrows(rows);
            this.dgService.sortRowClear$.next(rows);
        }
        if (this.dgService.previousClickedColumn !== column) {
            this.dgService.previousClickedColumn = column;
            this.sortStatus = DataGridSortDirection.none;
        }
    }
    updatePreviousCellArrows(rows) {
        if (this.dgService.previousClickedColumn) {
            const previousCell = Array.from(rows).find(cell => cell.textContent?.trim() === this.dgService.previousClickedColumn);
            if (previousCell) {
                this.replaceSortClass(previousCell, 'sort-none');
                previousCell.setAttribute('aria-sort', 'none');
            }
        }
    }
    addSortElements() {
        this.elementRef.nativeElement.classList.add('is-sortable');
        this.elementRef.nativeElement.classList.add(`sort-${this.sortStatus.toString()}`);
        this.addSortButton();
    }
    removeSortElements() {
        this.elementRef.nativeElement.classList.remove('is-sortable');
        this.elementRef.nativeElement.classList.remove(`sort-${this.sortStatus.toString()}`);
        this.removeSortButton();
    }
    updateSortStatus() {
        this._setSortStatus();
        this.replaceSortClass(this.elementRef.nativeElement, `sort-${this.sortStatus.toString()}`);
        this.sort.emit(this.sortStatus);
    }
    createSortButtonIfNotExist() {
        if (this.sortable && !this.sortButton) {
            this.addSortButton();
        }
    }
    addSortButton() {
        const children = this.elementRef.nativeElement.querySelectorAll(':not(.resize-holder)');
        const sortButton = this.renderer.createElement('button');
        this.renderer.addClass(sortButton, SORT_BUTTON_CLASS);
        if (children.length === 0) {
            if (this.elementRef.nativeElement.innerText) {
                sortButton.innerText = this.elementRef.nativeElement.innerText;
                this.elementRef.nativeElement.innerHTML = sortButton.outerHTML;
            }
        }
        else {
            this.renderer.appendChild(this.elementRef.nativeElement, sortButton);
            children?.forEach(child => {
                this.renderer.removeChild(this.elementRef.nativeElement, child);
                this.renderer.appendChild(sortButton, child);
            });
        }
        this.handleClick(this.sortable);
    }
    removeSortButton() {
        if (this.sortButton) {
            const children = this.sortButton.childNodes;
            children.forEach(child => {
                this.renderer.appendChild(this.element.nativeElement, child);
            });
            this.renderer.removeChild(this.elementRef.nativeElement, this.sortButton);
        }
    }
    replaceSortClass(cell, newStatus) {
        cell?.classList.forEach((item) => {
            if (item.startsWith('sort-')) {
                cell.classList.remove(item);
                cell.classList.add(newStatus);
            }
        });
    }
    updateAriaSort(status, sortable) {
        if (sortable) {
            this.elementRef.nativeElement.setAttribute('aria-sort', status);
        }
        else {
            this.elementRef.nativeElement.removeAttribute('aria-sort');
        }
    }
    updateAriaDescription(value) {
        if (value) {
            this.renderer.setAttribute(this.sortButton, 'aria-description', value);
        }
        else {
            this.renderer.removeAttribute(this.sortButton, 'aria-description');
        }
    }
    handleClick(sortable) {
        if (sortable && this.sortButton) {
            this.sortButton.addEventListener('click', this.clickEventListener);
        }
    }
    _setSortStatus() {
        switch (this.sortStatus) {
            case DataGridSortDirection.none:
                this.sortStatus = DataGridSortDirection.asc;
                break;
            case DataGridSortDirection.desc:
                this.sortStatus = DataGridSortDirection.none;
                break;
            case DataGridSortDirection.asc:
                this.sortStatus = DataGridSortDirection.desc;
                break;
            default:
                this.sortStatus = DataGridSortDirection.asc;
                break;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricHeaderCellDirective, deps: [{ token: i1.CdkColumnDef }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: forwardRef(() => DataGridService) }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricHeaderCellDirective, isStandalone: true, selector: "centric-header-cell, th[centric-header-cell], td[centric-header-cell]", inputs: { isResizable: "isResizable", fixedWidth: "fixedWidth", resizeWidth: "resizeWidth", sortable: "sortable", ariaDescription: "ariaDescription", isHeaderContentAlignedToRight: "isHeaderContentAlignedToRight", singleColumnSort: "singleColumnSort", sortStatus: "sortStatus" }, outputs: { sort: "sort", resizePropertiesChange: "resizePropertiesChange" }, host: { properties: { "class.centric-header-cell": "this.containerClass", "class.is-resizable": "this.isResizable" } }, usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricHeaderCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'centric-header-cell, th[centric-header-cell], td[centric-header-cell]',
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i1.CdkColumnDef }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: DataGridService, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => DataGridService)]
                }] }], propDecorators: { containerClass: [{
                type: HostBinding,
                args: ['class.centric-header-cell']
            }], isResizable: [{
                type: HostBinding,
                args: ['class.is-resizable']
            }, {
                type: Input
            }], fixedWidth: [{
                type: Input
            }], resizeWidth: [{
                type: Input
            }], sortable: [{
                type: Input
            }], ariaDescription: [{
                type: Input
            }], isHeaderContentAlignedToRight: [{
                type: Input
            }], singleColumnSort: [{
                type: Input
            }], sortStatus: [{
                type: Input
            }], sort: [{
                type: Output
            }], resizePropertiesChange: [{
                type: Output
            }] } });

class DataGridSource extends DataSource {
    _renderData = new BehaviorSubject([]);
    connect() {
        return this._renderData;
    }
    disconnect() {
        throw new Error('Not implemented');
    }
}

const cdkComponents = [CdkTableModule, DataRowOutlet, FooterRowOutlet, HeaderRowOutlet, NoDataRowOutlet];
/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricTableComponent`:
 * @example
 * ```typescript
 * import { CentricTableComponent } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricTableComponent extends CdkTable {
    containerClass = true;
    /**
     * Can toggle the filters you defined in the table
     */
    filters = false;
    /**
     * Data grid could have header fixed
     * The fixed header works only when the table has a specified height
     */
    fixedHeader = false;
    /**
     * Can make the rows dense (36px)
     */
    get dense() {
        return this._dense;
    }
    set dense(newValue) {
        this._dense = newValue;
        this._updateRowMinWidth();
    }
    /**
     * Can make the rows smaller (32px)
     */
    get smallRows() {
        return this._smallRows;
    }
    set smallRows(newValue) {
        this._smallRows = newValue;
        this._updateRowMinWidth();
    }
    /**
     * Text will wrap on the next line instead of using ellipsis
     */
    get wrapCellText() {
        return this._wrapCellText;
    }
    set wrapCellText(newValue) {
        this._wrapCellText = newValue;
    }
    get dataSource() {
        return super.dataSource;
    }
    set dataSource(dataSource) {
        super.dataSource = dataSource;
        if (this._elementRef.nativeElement?.firstElementChild) {
            setTimeout(() => {
                if (!this.subscription.closed) {
                    this.updateStickyColumnStyles();
                }
            });
        }
    }
    headerCells;
    stickyCssClass = 'centric-dg-sticky';
    _wrapCellText = false;
    _dense = false;
    _smallRows = false;
    subscription = new Subscription();
    mutationTableObserver;
    resizeTableObserver;
    get minWidthSize() {
        if (this.smallRows) {
            return DataGridMinWidthSize.small;
        }
        return this.dense ? DataGridMinWidthSize.dense : DataGridMinWidthSize.default;
    }
    ngAfterViewInit() {
        this._observeTableMutation();
        this._observeFirstThResize();
        setTimeout(() => {
            this._subscribeToResizePropertiesChanges();
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.mutationTableObserver?.disconnect();
        this.resizeTableObserver?.disconnect();
        this.subscription?.unsubscribe();
    }
    refreshGridSorting(resetSortStatus) {
        const htmlElement = this._elementRef.nativeElement;
        const headerRow = htmlElement?.children?.[0]?.children?.[0];
        if (headerRow) {
            const rowCells = headerRow.children;
            this._removeSortClass(rowCells);
            if (resetSortStatus) {
                this.headerCells.forEach(cell => {
                    cell.sortStatus = DataGridSortDirection.none;
                });
            }
        }
    }
    _observeFirstThResize() {
        this.resizeTableObserver = new ResizeObserver(() => {
            this.updateStickyColumnStyles();
            this._updateRowMinWidth();
        });
        const firstHeaderCellElement = this._elementRef.nativeElement.querySelectorAll('thead th')[0];
        if (firstHeaderCellElement instanceof Element) {
            this.resizeTableObserver.observe(firstHeaderCellElement);
        }
    }
    _observeTableMutation() {
        this.mutationTableObserver = new MutationObserver((mutations) => {
            this._updateOnChildListMutation(mutations);
            this._updateOnFiltersMutation(mutations);
        });
        const options = { attributes: true, attributeFilter: ['class'], childList: true, subtree: true };
        this.mutationTableObserver.observe(this._elementRef.nativeElement, { ...options });
    }
    _removeSortClass(row) {
        for (const cell of Array.from(row)) {
            for (const cssClass of Array.from(cell.classList)) {
                if (cssClass.includes('sort-')) {
                    cell.classList.remove(cssClass);
                    cell.classList.add('sort-none');
                }
            }
        }
    }
    _subscribeToResizePropertiesChanges() {
        this.headerCells?.forEach(headerCell => {
            this.subscription.add(headerCell.resizePropertiesChange.subscribe(() => {
                this._updateRowMinWidth();
            }));
        });
    }
    _updateRowMinWidth() {
        const bodyFirstRowCellArray = (this._elementRef?.nativeElement).querySelectorAll('tbody tr:first-child td');
        const headFirstRowCellArray = (this._elementRef?.nativeElement).querySelectorAll('thead tr:first-child th');
        let rowMinWidth = 0;
        if (bodyFirstRowCellArray.length > 0) {
            rowMinWidth = this._calculateMinWidth(bodyFirstRowCellArray);
        }
        else if (headFirstRowCellArray.length > 0) {
            rowMinWidth = this._calculateMinWidth(headFirstRowCellArray);
        }
        this._setMinWidthAttribute(rowMinWidth);
    }
    _setMinWidthAttribute(minWidth) {
        const bodyFirstRowElement = (this._elementRef?.nativeElement).querySelectorAll('tbody tr:first-child')[0];
        const headFirstRowElement = (this._elementRef?.nativeElement).querySelectorAll('thead tr:first-child')[0];
        bodyFirstRowElement?.setAttribute('style', `min-width: ${minWidth}px`);
        headFirstRowElement?.setAttribute('style', `min-width: ${minWidth}px`);
        this._changeDetectorRef.detectChanges();
    }
    _calculateMinWidth(cellsArray) {
        let minWidth = 0;
        for (let index = 0; index < cellsArray.length; index++) {
            const columnWidth = this._getColumnWidth(cellsArray, index);
            if (columnWidth) {
                minWidth = minWidth + columnWidth;
            }
        }
        return minWidth;
    }
    _getColumnWidth(cellsArray, index) {
        const columnMaxWidthValue = window.getComputedStyle(cellsArray[index]).getPropertyValue('max-width');
        const hasMixinApplied = columnMaxWidthValue !== 'none';
        const columnMaxWidth = parseInt(columnMaxWidthValue);
        const hasFixedWidthApplied = this.headerCells.toArray()[index]?.fixedWidth !== null;
        const columnFixedWidth = this.headerCells.toArray()[index]?.fixedWidth;
        if (hasMixinApplied) {
            return columnMaxWidth;
        }
        else if (hasFixedWidthApplied) {
            return columnFixedWidth;
        }
        return this.minWidthSize;
    }
    _updateOnChildListMutation(mutations) {
        let hasFirstMutation = false;
        mutations.forEach(mutation => {
            if (mutation.type === 'childList' && !hasFirstMutation) {
                this._updateRowMinWidth();
                hasFirstMutation = true;
            }
        });
    }
    _updateOnFiltersMutation(mutations) {
        if (mutations[0] &&
            !mutations[0].target.className.includes('is-resizing') &&
            mutations[0].target.className.includes('has-filters')) {
            this.updateStickyColumnStyles();
            this._updateRowMinWidth();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricTableComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.2.10", type: CentricTableComponent, isStandalone: true, selector: "centric-dg, table[centric-dg]", inputs: { filters: "filters", fixedHeader: "fixedHeader", dense: "dense", smallRows: "smallRows", wrapCellText: "wrapCellText", dataSource: "dataSource" }, host: { properties: { "class.centric-dg": "this.containerClass", "class.has-filters": "this.filters", "class.has-fixed-header": "this.fixedHeader", "class.is-dense": "this.dense", "class.is-small": "this.smallRows", "class.wrap-cell": "this.wrapCellText" } }, providers: [
            DataGridService,
            { provide: _COALESCED_STYLE_SCHEDULER, useClass: _CoalescedStyleScheduler },
            { provide: _VIEW_REPEATER_STRATEGY, useClass: _DisposeViewRepeaterStrategy },
            { provide: CDK_TABLE, useExisting: CentricTableComponent }
        ], queries: [{ propertyName: "headerCells", predicate: CentricHeaderCellDirective }], exportAs: ["centricDg"], usesInheritance: true, ngImport: i0, template: "\n  <ng-content select=\"caption\"/>\n  <ng-content select=\"colgroup, col\"/>\n\n  <!--\n    Unprojected content throws a hydration error so we need this to capture it.\n    It gets removed on the client so it doesn't affect the layout.\n  -->\n  @if (_isServer) {\n    <ng-content/>\n  }\n\n  @if (_isNativeHtmlTable) {\n    <thead role=\"rowgroup\">\n      <ng-container headerRowOutlet/>\n    </thead>\n    <tbody role=\"rowgroup\">\n      <ng-container rowOutlet/>\n      <ng-container noDataRowOutlet/>\n    </tbody>\n    <tfoot role=\"rowgroup\">\n      <ng-container footerRowOutlet/>\n    </tfoot>\n  } @else {\n    <ng-container headerRowOutlet/>\n    <ng-container rowOutlet/>\n    <ng-container noDataRowOutlet/>\n    <ng-container footerRowOutlet/>\n  }\n", isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: CdkTableModule }, { kind: "directive", type: i1.DataRowOutlet, selector: "[rowOutlet]" }, { kind: "directive", type: i1.HeaderRowOutlet, selector: "[headerRowOutlet]" }, { kind: "directive", type: i1.FooterRowOutlet, selector: "[footerRowOutlet]" }, { kind: "directive", type: i1.NoDataRowOutlet, selector: "[noDataRowOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricTableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'centric-dg, table[centric-dg]',
                    exportAs: 'centricDg',
                    template: CDK_TABLE_TEMPLATE,
                    encapsulation: ViewEncapsulation.None,
                    imports: [CommonModule, ...cdkComponents],
                    providers: [
                        DataGridService,
                        { provide: _COALESCED_STYLE_SCHEDULER, useClass: _CoalescedStyleScheduler },
                        { provide: _VIEW_REPEATER_STRATEGY, useClass: _DisposeViewRepeaterStrategy },
                        { provide: CDK_TABLE, useExisting: CentricTableComponent }
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true
                }]
        }], propDecorators: { containerClass: [{
                type: HostBinding,
                args: ['class.centric-dg']
            }], filters: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.has-filters']
            }], fixedHeader: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.has-fixed-header']
            }], dense: [{
                type: HostBinding,
                args: ['class.is-dense']
            }, {
                type: Input
            }], smallRows: [{
                type: HostBinding,
                args: ['class.is-small']
            }, {
                type: Input
            }], wrapCellText: [{
                type: HostBinding,
                args: ['class.wrap-cell']
            }, {
                type: Input
            }], dataSource: [{
                type: Input
            }], headerCells: [{
                type: ContentChildren,
                args: [CentricHeaderCellDirective]
            }] } });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricRowComponent`:
 * @example
 * ```typescript
 * import { CentricRowComponent } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricRowComponent extends CdkRow {
    /**
     * Property can be used to mark the row as selected
     */
    selected = false;
    containerClass = true;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: CentricRowComponent, isStandalone: true, selector: "centric-row, tr[centric-row]", inputs: { selected: "selected" }, host: { properties: { "class.selected": "this.selected", "class.centric-row": "this.containerClass" } }, providers: [{ provide: CdkRow, useExisting: CentricRowComponent }], exportAs: ["centricRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, dependencies: [{ kind: "directive", type: CdkCellOutlet, selector: "[cdkCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'centric-row, tr[centric-row]',
                    exportAs: 'centricRow',
                    template: CDK_ROW_TEMPLATE,
                    imports: [CdkCellOutlet],
                    providers: [{ provide: CdkRow, useExisting: CentricRowComponent }],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true
                }]
        }], propDecorators: { selected: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.selected']
            }], containerClass: [{
                type: HostBinding,
                args: ['class.centric-row']
            }] } });

const ACTIVE_RESIZE_CLASS_NAME = 'is-resizing';
const FILTERS_CLASS = 'has-filters';
const FILTER_CELL_CLASS = 'centric-column-filter-cell';
const RESIZE_HOLDER_CLASS = 'resize-holder';
const SELECTION_ROW_CONTENT_CLASS = 'row-item-selection';
const CDK_COLUMN_CLASS = 'cdk-column';
const SMALL_CLASS = 'is-small';
const DENSE_CLASS = 'is-dense';
/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricResizeColumnsDirective`:
 * @example
 * ```typescript
 * import { CentricResizeColumnsDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricResizeColumnsDirective {
    renderer;
    centricTableRef;
    hasResizeDirective = true;
    /**
     * Enable the resize on the columns of a table
     */
    get isResizeActive() {
        return this._isResizeActive;
    }
    set isResizeActive(value) {
        this._isResizeActive = value;
        if (value) {
            setTimeout(() => {
                this.initializeColumns(this.headerCells);
                this.checkUserInteraction();
                this.subscribeToResizePropertiesChanges();
            });
            this.observeFilterCellsMutation();
            this.observeTableResize();
            this.observeBodyMutation();
        }
        else {
            this.removeResizeHolders();
            if (this.getTotalColumnsWidth(true) < this.tableHtmlElement.clientWidth) {
                this.updateColumnsWidth();
            }
        }
    }
    /**
     * Emits when a column is resized
     */
    columnResizeChange = new EventEmitter();
    headerCells;
    tableRows;
    pressed = false;
    currentResizeIndex;
    startPoint;
    startWidth;
    isInitialUpdate = false;
    hasResizedColumns = false;
    columns = [];
    resizableMousemove;
    resizableMouseup;
    headerCellsSubscription = Subscription.EMPTY;
    tableHtmlElement;
    hasUserInteraction = false;
    resizeTableObserver;
    mutationObserver;
    mutationObserverBody;
    mutationObserverHead;
    mutationObserverTableClass;
    _isResizeActive = true;
    get minWidth() {
        const tableClassList = this.tableHtmlElement.className.split(' ');
        if (tableClassList.includes(SMALL_CLASS)) {
            return DataGridMinWidthSize.small;
        }
        return tableClassList.includes(DENSE_CLASS) ? DataGridMinWidthSize.dense : DataGridMinWidthSize.default;
    }
    constructor(renderer, centricTableRef) {
        this.renderer = renderer;
        this.centricTableRef = centricTableRef;
        this.tableHtmlElement = centricTableRef.nativeElement;
    }
    ngAfterViewInit() {
        if (!this.isResizeActive) {
            this.subscribeToHeaderCellsChanges();
            this.subscribeToResizePropertiesChanges();
        }
        this.observeTableHeadResize();
        this.isInitialUpdate = true;
        if (this.isInitialUpdate) {
            setTimeout(() => {
                this.initializeColumns(this.headerCells);
                this.updateColumnsWidth();
                this.observeTableResize();
                this.observeFilterCellsMutation();
                this.observeHeadMutation();
                if (this.isResizeActive) {
                    this.observeBodyMutation();
                }
                this.observeTableClassMutation();
            });
        }
    }
    ngOnDestroy() {
        if (this.resizeTableObserver) {
            this.resizeTableObserver.disconnect();
        }
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
        if (this.mutationObserverTableClass) {
            this.mutationObserverTableClass.disconnect();
        }
        if (this.headerCellsSubscription) {
            this.headerCellsSubscription.unsubscribe();
        }
    }
    observeBodyMutation() {
        this.mutationObserverBody = new MutationObserver((mutations) => {
            if (!this.isInitialUpdate) {
                mutations.forEach((mutation) => {
                    if (mutation.target.className.includes('mat-tooltip') ||
                        mutation.target.nodeName.includes('MAT-TOOLTIP-COMPONENT')) {
                        return;
                    }
                    if (mutation.type === 'attributes' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.className.includes('centric-row')) {
                        this.initializeColumns(this.headerCells);
                        this.columns.forEach(column => {
                            this.setColumnWidth(column);
                        });
                    }
                });
            }
        });
        const options = { attributes: true, subtree: true };
        if (this.tableHtmlElement.getElementsByTagName('tbody')[0]) {
            this.mutationObserverBody.observe(this.tableHtmlElement.getElementsByTagName('tbody')[0], options);
        }
    }
    observeTableClassMutation() {
        this.mutationObserverTableClass = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                const oldClasses = mutation?.oldValue ? mutation.oldValue.split(' ') : [];
                const currentClasses = mutation.target.className.split(' ');
                const modifiedClasses = this.getModifiedClasses(oldClasses, currentClasses);
                if (modifiedClasses.includes(SMALL_CLASS) || modifiedClasses.includes(DENSE_CLASS)) {
                    this.updateColumnsWidth();
                }
            });
        });
        const options = { attributes: true, attributeFilter: ['class'], attributeOldValue: true };
        if (this.tableHtmlElement) {
            this.mutationObserverTableClass.observe(this.tableHtmlElement, options);
        }
    }
    observeHeadMutation() {
        this.mutationObserverHead = new MutationObserver(() => noop);
        const options = { attributes: true, subtree: true };
        this.mutationObserverHead.observe(this.tableHtmlElement.getElementsByTagName('thead')[0], options);
    }
    observeTableResize() {
        this.resizeTableObserver = new ResizeObserver(() => {
            if (!this.hasResizedColumns) {
                this.updateColumnsWidth();
            }
        });
        this.resizeTableObserver.observe(this.tableHtmlElement);
    }
    observeTableHeadResize() {
        this.resizeTableObserver = new ResizeObserver(() => {
            const heightHeader = this.tableHtmlElement
                .getElementsByTagName('thead')[0]
                .getElementsByClassName('centric-header-row')[0]?.clientHeight;
            const classNameTable = this.tableHtmlElement.className;
            this.renderer.removeClass(this.tableHtmlElement, String(classNameTable.match(/height-header-\S+/g)));
            this.renderer.addClass(this.tableHtmlElement, `height-header-${heightHeader}`);
        });
        this.resizeTableObserver.observe(this.tableHtmlElement.getElementsByTagName('thead')[0]);
    }
    observeFilterCellsMutation() {
        this.mutationObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' &&
                    mutation.attributeName === 'class' &&
                    mutation.target.className.includes(FILTERS_CLASS))
                    this.columns.forEach(column => {
                        this.setFilterColumnWidth(this.columns.indexOf(column), column.width);
                    });
            });
        });
        const options = { attributes: true };
        this.mutationObserver.observe(this.tableHtmlElement, options);
    }
    subscribeToHeaderCellsChanges() {
        this.headerCellsSubscription = this.headerCells.changes.subscribe((changes) => {
            if (!this.isInitialUpdate) {
                this.initializeColumns(changes);
            }
        });
    }
    subscribeToResizePropertiesChanges() {
        this.headerCells?.forEach(headerCell => {
            headerCell.resizePropertiesChange.subscribe(() => {
                const indexHeaderCell = Array.from(this.headerCells).indexOf(headerCell);
                const column = this.columns[indexHeaderCell];
                column.isResizable = headerCell.isResizable;
                const resizeWidth = headerCell.resizeWidth ?? column.width;
                const newWidth = column.isResizable ? resizeWidth : headerCell.fixedWidth;
                column.width = newWidth;
                column.hasCustomWidth = Boolean(headerCell.resizeWidth);
                this.setColumnWidth(column);
                this.setFilterColumnWidth(indexHeaderCell, newWidth);
                this.checkUserInteraction();
            });
        });
    }
    checkUserInteraction() {
        if (!this.hasUserInteraction) {
            this.updateColumnsWidth();
        }
    }
    initializeColumns(changes) {
        const previousColumns = this.columns;
        this.columns = [];
        changes.forEach((headerCell, index) => {
            const classList = headerCell.element.nativeElement.classList;
            if (!classList.contains(SELECTION_ROW_CONTENT_CLASS)) {
                const columnName = Array.from(headerCell.element.nativeElement.classList).find(element => element.startsWith(CDK_COLUMN_CLASS));
                if (columnName) {
                    const previousIndex = previousColumns.map(column => column.columnName).indexOf(columnName);
                    const newWidth = previousIndex >= 0 ? previousColumns[previousIndex].width : this.minWidth;
                    this.addColumn(headerCell, index, columnName, newWidth);
                }
            }
        });
        this.isInitialUpdate = false;
    }
    addColumn(headerCell, index, columnName, newWidth) {
        const isResizableColumn = headerCell.isResizable;
        const hasResizeHolder = Boolean(headerCell.element.nativeElement.querySelector('.resize-holder'));
        this.columns.push({
            columnName,
            width: this.getInitialWidthColumn(headerCell, newWidth),
            isResizable: isResizableColumn,
            hasCustomWidth: Boolean(headerCell.resizeWidth)
        });
        if (isResizableColumn && this.isResizeActive && !hasResizeHolder) {
            this.createResizerElement(headerCell, index);
        }
    }
    getInitialWidthColumn(headerCell, newWidth) {
        if (headerCell.isResizable && headerCell.resizeWidth && !this.hasResizedColumns) {
            return headerCell.resizeWidth;
        }
        if (!headerCell.isResizable) {
            return headerCell.fixedWidth;
        }
        return newWidth;
    }
    createResizerElement(headerCell, index) {
        const resizer = this.renderer.createElement('span');
        this.renderer.addClass(resizer, RESIZE_HOLDER_CLASS);
        this.renderer.setAttribute(resizer, 'aria-hidden', 'true');
        this.renderer.appendChild(headerCell.element.nativeElement, resizer);
        this.renderer.listen(resizer, 'mousedown', (event) => {
            this.onResizerMouseDown(event, index);
        });
    }
    updateColumnsWidth() {
        const tableWidth = this.tableHtmlElement.clientWidth;
        const resizableColumnsWidth = this.getTotalColumnsWidth(true);
        const fixedColumnsWidth = this.getTotalColumnsWidth(false);
        const tableWidthWithColumns = tableWidth === 0 ? resizableColumnsWidth : tableWidth - fixedColumnsWidth;
        const scale = tableWidthWithColumns / resizableColumnsWidth;
        this.columns.forEach(column => {
            if (column.width) {
                const scaleWidth = column.width * scale;
                const newResizedWidth = scaleWidth >= this.minWidth ? scaleWidth : this.minWidth;
                const newWidth = column.isResizable ? (column.hasCustomWidth ? column.width : newResizedWidth) : column.width;
                column.width = newWidth;
                this.setColumnWidth(column);
                this.setFilterColumnWidth(this.columns.indexOf(column), newWidth);
            }
        });
    }
    onResizerMouseDown(event, index) {
        this.currentResizeIndex = index;
        this.updateResizeClass(true, index);
        this.pressed = true;
        this.startPoint = event.pageX;
        this.startWidth = event.target.parentElement?.clientWidth;
        event.preventDefault();
        this.listenMouseMove(index);
        this.listenMouseUp();
    }
    updateResizeClass(isResizing, index) {
        if (this.tableHtmlElement.classList.contains(FILTERS_CLASS)) {
            const filterCells = this.tableHtmlElement.getElementsByClassName(FILTER_CELL_CLASS);
            const filterCellToResize = filterCells[index];
            this.addOrRemoveClassOnResize(isResizing, filterCellToResize);
        }
        this.addOrRemoveClassForSelectionContent(isResizing, index);
        const resizedColumnClassName = Array.from(this.headerCells.toArray()[index].element.nativeElement.classList).find(element => element.startsWith(CDK_COLUMN_CLASS));
        if (resizedColumnClassName) {
            const cellsToResize = Array.from(this.tableHtmlElement.getElementsByClassName(resizedColumnClassName));
            cellsToResize.forEach(cell => {
                this.addOrRemoveClassOnResize(isResizing, cell);
            });
        }
    }
    addOrRemoveClassForSelectionContent(isResizing, index) {
        const isLastItem = index === this.columns?.length - 1;
        const selectionRow = this.tableHtmlElement.getElementsByClassName(SELECTION_ROW_CONTENT_CLASS)[0];
        if (isLastItem && selectionRow) {
            this.addOrRemoveClassOnResize(isResizing, selectionRow);
        }
    }
    addOrRemoveClassOnResize(isResizing, tableCell) {
        if (isResizing) {
            this.renderer.addClass(tableCell, ACTIVE_RESIZE_CLASS_NAME);
            this.renderer.addClass(this.centricTableRef.nativeElement, ACTIVE_RESIZE_CLASS_NAME);
        }
        else {
            this.renderer.removeClass(tableCell, ACTIVE_RESIZE_CLASS_NAME);
            this.renderer.removeClass(this.centricTableRef.nativeElement, ACTIVE_RESIZE_CLASS_NAME);
        }
    }
    listenMouseMove(index) {
        this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
            if (this.pressed && event.buttons && this.startPoint && this.startWidth) {
                this.hasResizedColumns = true;
                const distance = event.pageX - this.startPoint;
                const width = this.startWidth + distance;
                if (this.currentResizeIndex === index && width > this.minWidth) {
                    this.setColumnWidthChanges(index, width);
                    this.hasUserInteraction = true;
                }
            }
        });
    }
    setColumnWidthChanges(index, width) {
        const initialWidth = this.columns[index].width;
        if (initialWidth) {
            const distance = width - initialWidth;
            if (distance !== 0) {
                this.columns[index].width = width;
                this.columns[index].columnIndex = index;
                this.columnResizeChange.emit(this.columns[index]);
                this.setColumnWidth(this.columns[index]);
                this.setFilterColumnWidth(index, width);
            }
        }
    }
    setColumnWidth(column) {
        const columnsTable = Array.from(this.tableHtmlElement.getElementsByClassName(column.columnName));
        columnsTable?.forEach((columnCell) => {
            columnCell.style.width = `${column.width}px`;
        });
    }
    setFilterColumnWidth(index, width) {
        const hasFilters = this.tableHtmlElement.classList.contains(FILTERS_CLASS);
        if (hasFilters) {
            const columnsFiltersTable = Array.from(this.tableHtmlElement.getElementsByClassName(FILTER_CELL_CLASS));
            if (columnsFiltersTable?.length > 0 && width) {
                columnsFiltersTable[index].style.width = `${width}px`;
            }
        }
    }
    listenMouseUp() {
        this.resizableMouseup = this.renderer.listen('document', 'mouseup', () => {
            if (this.pressed) {
                this.pressed = false;
                this.updateResizeClass(false, this.currentResizeIndex);
                this.currentResizeIndex = -1;
                this.resizableMousemove();
                this.resizableMouseup();
            }
        });
    }
    removeResizeHolders() {
        const resizerElements = this.tableHtmlElement.getElementsByClassName(RESIZE_HOLDER_CLASS);
        Array.from(resizerElements).forEach(element => {
            this.renderer.removeChild(this.tableHtmlElement, element);
        });
    }
    getTotalColumnsWidth(isResizable) {
        let sum = 0;
        let sumNotResizable = 0;
        this.columns.forEach(column => {
            if (column.width) {
                if (column.isResizable && !column.hasCustomWidth) {
                    sum += column.width;
                }
                else {
                    sumNotResizable += column.width;
                }
            }
        });
        return isResizable ? sum : sumNotResizable;
    }
    getModifiedClasses(oldClasses, newClasses) {
        const addedClasses = newClasses.filter(item => !oldClasses.includes(item));
        const removedClasses = oldClasses.filter(item => !newClasses.includes(item));
        return addedClasses.concat(removedClasses);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricResizeColumnsDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricResizeColumnsDirective, isStandalone: true, selector: "[centricResizeColumns]", inputs: { isResizeActive: "isResizeActive" }, outputs: { columnResizeChange: "columnResizeChange" }, host: { properties: { "class.has-resize-directive": "this.hasResizeDirective", "class.is-resizable": "this.isResizeActive" } }, queries: [{ propertyName: "headerCells", predicate: CentricHeaderCellDirective }, { propertyName: "tableRows", predicate: CentricRowComponent }], ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricResizeColumnsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[centricResizeColumns]',
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.ElementRef }], propDecorators: { hasResizeDirective: [{
                type: HostBinding,
                args: ['class.has-resize-directive']
            }], isResizeActive: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.is-resizable']
            }], columnResizeChange: [{
                type: Output
            }], headerCells: [{
                type: ContentChildren,
                args: [CentricHeaderCellDirective]
            }], tableRows: [{
                type: ContentChildren,
                args: [CentricRowComponent]
            }] } });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricFilterHeaderRowDefDirective`:
 * @example
 * ```typescript
 * import { CentricFilterHeaderRowDefDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricFilterHeaderRowDefDirective extends CdkHeaderRowDef {
    columns;
    get sticky() {
        return this._customSticky;
    }
    set sticky(newValue) {
        this._customSticky = newValue;
    }
    _customSticky = false;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFilterHeaderRowDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricFilterHeaderRowDefDirective, isStandalone: true, selector: "[centricFilterHeaderRowDef]", inputs: { columns: ["centricFilterHeaderRowDef", "columns"], sticky: ["centricFilterHeaderRowDefSticky", "sticky"] }, providers: [{ provide: CdkHeaderRowDef, useExisting: CentricFilterHeaderRowDefDirective }], usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFilterHeaderRowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[centricFilterHeaderRowDef]',
                    providers: [{ provide: CdkHeaderRowDef, useExisting: CentricFilterHeaderRowDefDirective }],
                    standalone: true
                }]
        }], propDecorators: { columns: [{
                type: Input,
                args: ['centricFilterHeaderRowDef']
            }], sticky: [{
                type: Input,
                args: ['centricFilterHeaderRowDefSticky']
            }] } });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricFilterHeaderRowComponent`:
 * @example
 * ```typescript
 * import { CentricFilterHeaderRowComponent } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricFilterHeaderRowComponent extends CdkHeaderRow {
    containerClass = true;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFilterHeaderRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: CentricFilterHeaderRowComponent, isStandalone: true, selector: "centric-filter-header-row, tr[centric-filter-header-row]", host: { properties: { "class.centric-filter-header-row": "this.containerClass" } }, providers: [{ provide: CdkHeaderRow, useExisting: CentricFilterHeaderRowComponent }], exportAs: ["centricFilterHeaderRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, dependencies: [{ kind: "directive", type: CdkCellOutlet, selector: "[cdkCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFilterHeaderRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'centric-filter-header-row, tr[centric-filter-header-row]',
                    exportAs: 'centricFilterHeaderRow',
                    template: CDK_ROW_TEMPLATE,
                    imports: [CdkCellOutlet],
                    providers: [{ provide: CdkHeaderRow, useExisting: CentricFilterHeaderRowComponent }],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true
                }]
        }], propDecorators: { containerClass: [{
                type: HostBinding,
                args: ['class.centric-filter-header-row']
            }] } });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricFilterRowDefDirective`:
 * @example
 * ```typescript
 * import { CentricFilterRowDefDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricFilterRowDefDirective extends CdkRowDef {
    columns;
    when;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFilterRowDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricFilterRowDefDirective, isStandalone: true, selector: "[centricFilterRowDef]", inputs: { columns: ["centricFilterRowDefColumns", "columns"], when: ["centricFilterRowDefWhen", "when"] }, providers: [{ provide: CdkRowDef, useExisting: CentricFilterRowDefDirective }], usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFilterRowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[centricFilterRowDef]',
                    providers: [{ provide: CdkRowDef, useExisting: CentricFilterRowDefDirective }],
                    standalone: true
                }]
        }], propDecorators: { columns: [{
                type: Input,
                args: ['centricFilterRowDefColumns']
            }], when: [{
                type: Input,
                args: ['centricFilterRowDefWhen']
            }] } });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricFooterRowDefDirective`:
 * @example
 * ```typescript
 * import { CentricFooterRowDefDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricFooterRowDefDirective extends CdkFooterRowDef {
    columns;
    get sticky() {
        return this._customSticky;
    }
    set sticky(newValue) {
        this._customSticky = newValue;
    }
    _customSticky = false;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFooterRowDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricFooterRowDefDirective, isStandalone: true, selector: "[centricFooterRowDef]", inputs: { columns: ["centricFooterRowDef", "columns"], sticky: ["centricFooterRowDefSticky", "sticky"] }, providers: [{ provide: CdkFooterRowDef, useExisting: CentricFooterRowDefDirective }], usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFooterRowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[centricFooterRowDef]',
                    providers: [{ provide: CdkFooterRowDef, useExisting: CentricFooterRowDefDirective }],
                    standalone: true
                }]
        }], propDecorators: { columns: [{
                type: Input,
                args: ['centricFooterRowDef']
            }], sticky: [{
                type: Input,
                args: ['centricFooterRowDefSticky']
            }] } });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricFooterRowComponent`:
 * @example
 * ```typescript
 * import { CentricFooterRowComponent } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricFooterRowComponent extends CdkFooterRow {
    containerClass = true;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFooterRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: CentricFooterRowComponent, isStandalone: true, selector: "centric-footer-row, tr[centric-footer-row]", host: { properties: { "class.centric-footer-row": "this.containerClass" } }, providers: [{ provide: CdkFooterRow, useExisting: CentricFooterRowComponent }], exportAs: ["centricFooterRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, dependencies: [{ kind: "directive", type: CdkCellOutlet, selector: "[cdkCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricFooterRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'centric-footer-row, tr[centric-footer-row]',
                    exportAs: 'centricFooterRow',
                    template: CDK_ROW_TEMPLATE,
                    imports: [CdkCellOutlet],
                    providers: [{ provide: CdkFooterRow, useExisting: CentricFooterRowComponent }],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true
                }]
        }], propDecorators: { containerClass: [{
                type: HostBinding,
                args: ['class.centric-footer-row']
            }] } });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricHeaderRowDefDirective`:
 * @example
 * ```typescript
 * import { CentricHeaderRowDefDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricHeaderRowDefDirective extends CdkHeaderRowDef {
    columns;
    get sticky() {
        return this._customSticky;
    }
    set sticky(newValue) {
        this._customSticky = newValue;
    }
    _customSticky = false;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricHeaderRowDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricHeaderRowDefDirective, isStandalone: true, selector: "[centricHeaderRowDef]", inputs: { columns: ["centricHeaderRowDef", "columns"], sticky: ["centricHeaderRowDefSticky", "sticky"] }, providers: [{ provide: CdkHeaderRowDef, useExisting: CentricHeaderRowDefDirective }], usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricHeaderRowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[centricHeaderRowDef]',
                    providers: [{ provide: CdkHeaderRowDef, useExisting: CentricHeaderRowDefDirective }],
                    standalone: true
                }]
        }], propDecorators: { columns: [{
                type: Input,
                args: ['centricHeaderRowDef']
            }], sticky: [{
                type: Input,
                args: ['centricHeaderRowDefSticky']
            }] } });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricHeaderRowComponent`:
 * @example
 * ```typescript
 * import { CentricHeaderRowComponent } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricHeaderRowComponent extends CdkHeaderRow {
    containerClass = true;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricHeaderRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: CentricHeaderRowComponent, isStandalone: true, selector: "centric-header-row, tr[centric-header-row]", host: { properties: { "class.centric-header-row": "this.containerClass" } }, providers: [{ provide: CdkHeaderRow, useExisting: CentricHeaderRowComponent }], exportAs: ["centricHeaderRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, dependencies: [{ kind: "directive", type: CdkCellOutlet, selector: "[cdkCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricHeaderRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'centric-header-row, tr[centric-header-row]',
                    exportAs: 'centricHeaderRow',
                    template: CDK_ROW_TEMPLATE,
                    imports: [CdkCellOutlet],
                    providers: [{ provide: CdkHeaderRow, useExisting: CentricHeaderRowComponent }],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true
                }]
        }], propDecorators: { containerClass: [{
                type: HostBinding,
                args: ['class.centric-header-row']
            }] } });

/**
 * To use this component in a module, you can import the `CentricDataGridModule`:
 * @example
 * ```typescript
 * import { CentricDataGridModule } from '@windmill/ng-windmill/data-grid';
 * ```
 *
 * To use the standalone component directly, you can import `CentricRowDefDirective`:
 * @example
 * ```typescript
 * import { CentricRowDefDirective } from '@windmill/ng-windmill/data-grid';
 * ```
 */
class CentricRowDefDirective extends CdkRowDef {
    columns;
    when;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricRowDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: CentricRowDefDirective, isStandalone: true, selector: "[centricRowDef]", inputs: { columns: ["centricRowDefColumns", "columns"], when: ["centricRowDefWhen", "when"] }, providers: [{ provide: CdkRowDef, useExisting: CentricRowDefDirective }], usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricRowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[centricRowDef]',
                    providers: [{ provide: CdkRowDef, useExisting: CentricRowDefDirective }],
                    standalone: true
                }]
        }], propDecorators: { columns: [{
                type: Input,
                args: ['centricRowDefColumns']
            }], when: [{
                type: Input,
                args: ['centricRowDefWhen']
            }] } });

const moduleComponents = [
    CentricCellDefDirective,
    CentricCellDirective,
    CentricColumnDefDirective,
    CentricFilterCellDefDirective,
    CentricFilterCellDirective,
    CentricFilterHeaderRowComponent,
    CentricFilterHeaderRowDefDirective,
    CentricFilterRowDefDirective,
    CentricFooterCellDefDirective,
    CentricFooterCellDirective,
    CentricFooterRowComponent,
    CentricFooterRowDefDirective,
    CentricHeaderCellDefDirective,
    CentricHeaderCellDirective,
    CentricHeaderRowComponent,
    CentricHeaderRowDefDirective,
    CentricResizeColumnsDirective,
    CentricRowComponent,
    CentricRowDefDirective,
    CentricTableComponent
];
class CentricDataGridModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricDataGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: CentricDataGridModule, imports: [CommonModule, CdkTableModule, CentricCellDefDirective,
            CentricCellDirective,
            CentricColumnDefDirective,
            CentricFilterCellDefDirective,
            CentricFilterCellDirective,
            CentricFilterHeaderRowComponent,
            CentricFilterHeaderRowDefDirective,
            CentricFilterRowDefDirective,
            CentricFooterCellDefDirective,
            CentricFooterCellDirective,
            CentricFooterRowComponent,
            CentricFooterRowDefDirective,
            CentricHeaderCellDefDirective,
            CentricHeaderCellDirective,
            CentricHeaderRowComponent,
            CentricHeaderRowDefDirective,
            CentricResizeColumnsDirective,
            CentricRowComponent,
            CentricRowDefDirective,
            CentricTableComponent], exports: [CentricCellDefDirective,
            CentricCellDirective,
            CentricColumnDefDirective,
            CentricFilterCellDefDirective,
            CentricFilterCellDirective,
            CentricFilterHeaderRowComponent,
            CentricFilterHeaderRowDefDirective,
            CentricFilterRowDefDirective,
            CentricFooterCellDefDirective,
            CentricFooterCellDirective,
            CentricFooterRowComponent,
            CentricFooterRowDefDirective,
            CentricHeaderCellDefDirective,
            CentricHeaderCellDirective,
            CentricHeaderRowComponent,
            CentricHeaderRowDefDirective,
            CentricResizeColumnsDirective,
            CentricRowComponent,
            CentricRowDefDirective,
            CentricTableComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricDataGridModule, imports: [CommonModule, CdkTableModule, CentricTableComponent] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricDataGridModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CdkTableModule, ...moduleComponents],
                    exports: [...moduleComponents]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CentricCellDefDirective, CentricCellDirective, CentricColumnDefDirective, CentricDataGridModule, CentricFilterCellDefDirective, CentricFilterCellDirective, CentricFilterHeaderRowComponent, CentricFilterHeaderRowDefDirective, CentricFilterRowDefDirective, CentricFooterCellDefDirective, CentricFooterCellDirective, CentricFooterRowComponent, CentricFooterRowDefDirective, CentricHeaderCellDefDirective, CentricHeaderCellDirective, CentricHeaderRowComponent, CentricHeaderRowDefDirective, CentricResizeColumnsDirective, CentricRowComponent, CentricRowDefDirective, CentricTableComponent, DataGridMinWidthSize, DataGridSortDirection, DataGridSource };
